import type { Vec2 } from './vec2';

export type Transform = [number, number, number, number, number, number];

export const Transform = {
  mul(x: Transform, y: Transform): Transform {
    const [a1, b1, c1, d1, e1, f1] = x;
    const [a2, b2, c2, d2, e2, f2] = y;
    return [
      a1 * a2 + c1 * b2,
      b1 * a2 + d1 * b2,
      a1 * c2 + c1 * d2,
      b1 * c2 + d1 * d2,
      a1 * e2 + c1 * f2 + e1,
      b1 * e2 + d1 * f2 + f1
    ];
  },
  transformPoint(t: Transform, p: Vec2): Vec2 {
    const [a, b, c, d, e, f] = t;
    return {
      x: p.x * a + p.y * c + e,
      y: p.x * b + p.y * d + f
    };
  },
  transformPoints(t: Transform, ps: Vec2[]): Vec2[] {
    return ps.map((p) => this.transformPoint(t, p));
  }
};
